import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
} from "reactstrap";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import "./jobGuaranteeMobile.css";
import "../style.css";
import handleValidation from "../../../Validation";

class JobGuaranteeMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }
  submitDetails = event => {
    debugger;
    let formData = {
      first_name: this.refs.first_name.value,
      //last_name: this.refs.last_name.value,
      email: this.refs.email.value,
      contact: this.refs.phone.value
    };
    let errors = handleValidation(formData);
    this.setState({ errors: errors });

    if (errors["valid"] === true) {
      document.getElementById("scheduleCall").action =
        "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8";
      document.getElementById("scheduleCall").method = "POST";
    } else {
      this.setState({ errorsdiv: true });
      event.preventDefault();
    }
  };

  toggle() {
    this.setState(prevState => ({
      modal: !prevState.modal
    }));
  }

  render() {
    return (
      <div>
        <div className="jobg-mobile">
          <img
            className="jobg-mobile-banner"
            src={require("../../../images/job-guarantee-background-v2-mobile.png")}
            alt="job guarentee banner"
          />
        </div>
        <Container>
          <Row>
            <Col xs={{ size: 12 }} className="pt-lg-4">
              <h1 className=" all-headers">
                It's More Than A Job Guarentee
              </h1>
              <p className="job-guarantee-description">
                At Lighthouse, our career services team works with you to get
                hired, and our mentors work with you to stay inspired
                in your entire career journey.
                <br />
                <br />
                We do not want you to feel stuck after you have secured a job.
                With technology changing every few years, you will be developing
                new and valuable skills as the industry evolves. We want to help
                you keep your curiosity and spark, so that you can
                continue to stay relevant, forever. Learn more about how we will
                work with you through your career and keep adding emerging
                skills.
                <br />
                <br />
                <span className="start-now">start now</span>
              </p>
            </Col>
          </Row>
          <Row>
            <Col
              xs={{ size: 12 }}
              className="d-flex  pt-3"
            >
              <Button className="job-btn" onClick={this.toggle}>
                Schedule A Call
              </Button>{" "}
            </Col>
          </Row>
        </Container>
        <Modal
          isOpen={this.state.modal}
          toggle={this.toggle}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}>Schedule A Call</ModalHeader>
          <form
            id="scheduleCall"
            action=""
            method=""
            onSubmit={this.submitDetails.bind(this)}
          >
            <input
              type="hidden"
              name="00N3i00000Bm5C9"
              value="Schedule a call"
            />
            <input type="hidden" name="lead_source" value="Website" />
            <input type="hidden" name="oid" value="00D3i000000GUvA" />
            <input
              type="hidden"
              name="last_name"
              value={this.state.last_name}
            />
            <input
              type="hidden"
              name="first_name"
              value={this.state.first_name}
            />
            <input
              type="hidden"
              name="retURL"
              value="https://atlighthouse.com/thank-you-submission"
            />
            <ModalBody>
              <Row>
                <Col sm={{ size: 12 }}>
                  <FormGroup>
                    <Label htmlFor="exampleName">Full Name</Label>
                    <input
                      id="first_name"
                      maxLength="40"
                      name="firstname"
                      size="20"
                      type="text"
                      className="apply-now-inputs form-control"
                      //value={this.state.first_name}
                      ref="first_name"
                      onChange={this.splitString}
                    />
                    {this.state.errorsdiv === true ? (
                      <span className="error">
                        {this.state.errors["first_name"]}
                      </span>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={{ size: 12 }}>
                  <FormGroup>
                    <Label htmlFor="exampleEmail">Email</Label>
                    <input
                      id="email"
                      maxLength="80"
                      name="email"
                      size="20"
                      type="text"
                      className="apply-now-inputs form-control"
                      ref="email"
                    />
                    {this.state.errorsdiv === true ? (
                      <span className="error">
                        {this.state.errors["email"]}
                      </span>
                    ) : (
                      ""
                    )}
                    <br />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col sm={{ size: 12 }}>
                  <FormGroup>
                    <Label htmlFor="examplePhoneNumber">Phone Number</Label>
                    <input
                      id="phone"
                      maxLength="40"
                      name="phone"
                      size="20"
                      type="text"
                      className="apply-now-inputs form-control"
                      ref="phone"
                    />
                    {this.state.errorsdiv === true ? (
                      <span className="error">
                        {this.state.errors["contact"]}
                      </span>
                    ) : (
                      ""
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button style={{ width: "8rem", backgroundColor:"#b22424",  }}>Send</Button>{" "}
              </div>
            </ModalBody>
          </form>

          <ModalFooter>
            <Row>
            <Col sm={{ size: 12 }}>
                <p>
                  <i style={{color:"grey", fontSize:".65rem"}}>
                    By providing your email, you agree to our{" "}
                    <u>
                      <Link style={{ color: "grey" }} to="/privacy-policy">
                        privacy policy
                      </Link>
                    </u>{" "}
                    and{" "}
                    <u>
                      <Link style={{ color: "grey" }} to="/terms-of-service">
                        terms and conditions
                      </Link>
                    </u>
                  </i>
                  .
                </p>
              </Col>
            </Row>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default JobGuaranteeMobile;
